module.exports = __webpack_public_path__ + "assets/img/921793dac062f73657b27670749dbc6a.svg";